import { render } from "./studioInfo.vue?vue&type=template&id=35adc497&scoped=true"
import script from "./studioInfo.vue?vue&type=script&lang=js"
export * from "./studioInfo.vue?vue&type=script&lang=js"

import "./studioInfo.vue?vue&type=style&index=0&id=35adc497&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35adc497"]])

export default __exports__